import { ExplorerItem } from "@/types/types.ts";
import fetchInstance from "@/services/fetch.ts";

export async function createExplorerItemLike(
  {
    explorerItem,
    uniqueTabId,
  }:
  {
    explorerItem: ExplorerItem,
    uniqueTabId: string,
  }) {
  return fetchInstance.post(
    `/create-explorer-item-like/${explorerItem.id}`,
    { uniqueTabId },
  )
}

export async function deleteExplorerItemLike(
  {
    explorerItem,
    uniqueTabId,
  }:
  {
    explorerItem: ExplorerItem,
    uniqueTabId: string,
  }) {
  return fetchInstance.delete(
    `/delete-explorer-item-like/${explorerItem.id}`,
    { uniqueTabId },
  )
}
